import React from "react";
import { Box, Flex, Icon, Text } from "@thenounproject/lingo-core";
import { COLORS } from "../utils/constants";
import styled, { css } from "styled-components";
import { MobileMenuItem } from "./Header";
import LinkItemComponent from "./LinkItem";
import HighlightedItemComponent from "./HighlightedItem";
import Link from "next/link";

const SectionButtonStyling = css`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  width: min-content;
  background: none;
  border: none;
  cursor: pointer;
  color: ${COLORS.blue};
  width: 100%;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

const MobileSectionLink = styled(Link)`
  ${SectionButtonStyling}
`;

const MobileSectionButton = styled.button`
  ${SectionButtonStyling}
`;

type Props = {
  item: MobileMenuItem;
  isOpen: boolean;
  onToggle: () => void;
};

const MobileMenuSection = ({ item, isOpen, onToggle }: Props) => {
  const hasDropdown = item.columns && item.columns.length > 0;
  if (!hasDropdown && item.link) {
    return (
      <MobileSectionLink href={item.link}>
        <Text font="marketing.h4" color={COLORS.blue}>
          {item.text}
        </Text>
      </MobileSectionLink>
    );
  }

  return (
    <Box>
      <MobileSectionButton onClick={onToggle}>
        <Text font="marketing.h4" color={COLORS.blue}>
          {item.text}
        </Text>
        <Icon
          fill={COLORS.blue}
          iconId="navigation.nav-down"
          ml="8px"
          size={8}
          style={{
            transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.3s ease",
          }}
        />
      </MobileSectionButton>
      <Flex
        flexDirection="column"
        textAlign="left"
        gap="32px"
        maxHeight={isOpen ? "1000px" : 0}
        style={{ opacity: isOpen ? 1 : 0 }}
        transition="max-height 0.4s ease, opacity 0.3s ease"
        mt={isOpen ? "16px" : 0}
        overflow={isOpen ? "visible" : "hidden"}>
        {item.columns.map((column, idx) => (
          <Flex key={`${column.title || "untitled"}-${idx}`} flexDirection="column" gap="8px">
            {column.title && (
              <Text font="marketing.semiBold" color={COLORS.black}>
                {column.title}
              </Text>
            )}
            {column.items.map(link => (
              <LinkItemComponent key={link.id} link={link} />
            ))}
          </Flex>
        ))}
        {item?.dropdown?.highlightedItem && (
          <HighlightedItemComponent item={item.dropdown.highlightedItem} />
        )}
      </Flex>
    </Box>
  );
};

export default MobileMenuSection;
